import { render, staticRenderFns } from "./DirectSale.vue?vue&type=template&id=3dbc3642"
import script from "./DirectSale.vue?vue&type=script&lang=js"
export * from "./DirectSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports